<h1 mat-dialog-title>Copy Token</h1>
<div mat-dialog-content>
    <div class="flex row well warn">
        <mat-icon>warning</mat-icon>
        <span>Make sure to copy this access token now as you will NOT see it again.</span>
    </div>

    <form>
        <div class="flex row">
            <mat-form-field class="flex-100">
                <mat-label>Token</mat-label>
                <input matInput [value]="data" />
            </mat-form-field>
            <button mat-icon-button (click)="copyToken()">
                <mat-icon>content_copy</mat-icon>
            </button>
        </div>
    </form>
</div>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close>Close</button>
</div>
